import React, { useState } from "react";
import "./Product.css";

const screenshots = [
    { src: "assets/product/1.PNG", alt: "Pengelolaan master data barang" },
    { src: "assets/product/2.PNG", alt: "Monitoring stock barang" },
    { src: "assets/product/3.PNG", alt: "Kasir dan input saldo awal" },
    { src: "assets/product/4.PNG", alt: "Dashboard penjualan per jam" },
    { src: "assets/product/7.PNG", alt: "Dashboard hutang pelanggan" },
    { src: "assets/product/8.PNG", alt: "Analisis statistik penjualan" },
    { src: "assets/product/9.PNG", alt: "Cetak label barcode produk" },
    { src: "assets/product/10.PNG", alt: "Transaksi point of sales" },
];

const Product = () => {
    const [activeScreenshot, setActiveScreenshot] = useState(screenshots[0]);

    return (
        <div className="box right product-box">
            <section className="box-desc product-section" id="Product">
                <article>
                    <p className="product-eyebrow">Produk Unggulan</p>
                    <h2 className="title">Aplikasi Point of Sales & Inventory</h2>
                    <p className="hr-item" />
                    <p className="product-summary">
                        Solusi operasional toko untuk mengelola penjualan, stok,
                        pembelian, hutang, barcode, dan laporan dalam satu aplikasi.
                    </p>
                </article>

                <div className="product-actions">
                    <a
                        className="product-demo-button"
                        href="https://wa.me/6282242116118?text=Halo%20Budi%2C%20saya%20ingin%20meminta%20link%20demo%20Aplikasi%20Point%20of%20Sales%20%26%20Inventory."
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Minta Link Demo
                    </a>
                </div>

                <div className="product-features">
                    <span>Point of Sales</span>
                    <span>Inventory</span>
                    <span>Dashboard</span>
                    <span>Barcode</span>
                    <span>Laporan</span>
                </div>

                <div className="product-gallery">
                    <div className="product-preview">
                        <img src={activeScreenshot.src} alt={activeScreenshot.alt} />
                        <p>{activeScreenshot.alt}</p>
                    </div>
                    <div className="product-thumbnails">
                        {screenshots.map((screenshot) => (
                            <button
                                type="button"
                                key={screenshot.src}
                                className={
                                    screenshot.src === activeScreenshot.src
                                        ? "product-thumbnail active"
                                        : "product-thumbnail"
                                }
                                onClick={() => setActiveScreenshot(screenshot)}
                                aria-label={`Tampilkan ${screenshot.alt}`}
                            >
                                <img src={screenshot.src} alt="" />
                            </button>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Product;
